import React from 'react';

// Components
import classnames from 'classnames';

import { useAnalytics } from '@utils/analytics';
import IconFacebookComponent from '@shcc/components/icons/IconFacebookComponent/IconFacebookComponent';
import IconInstagramComponent from '@shcc/components/icons/IconInstagramComponent/IconInstagramComponent';
import IconTwitterComponent from '@shcc/components/icons/IconTwitterComponent/IconTwitterComponent';
import IconYoutubeComponent from '@shcc/components/icons/IconYoutubeComponent/IconYoutubeComponent';

// Styles
import styles from './ButtonSocialComponent.module.scss';

const ButtonSocialComponent = ({
  className,
  data,
  type,
  label = type,
  color,
}) => {
  const { trackInteraction } = useAnalytics();
  const classNames = classnames(
    'button',
    styles.button,
    styles['button--' + type],
    className
  );

  const _setIcon = () => {
    switch (type) {
      case 'facebook':
        return <IconFacebookComponent color={color} alt={data.link.alt} />;
      case 'instagram':
        return <IconInstagramComponent color={color} alt={data.link.alt} />;
      case 'twitter':
        return <IconTwitterComponent color={color} alt={data.link.alt} />;
      case 'youtube':
        return <IconYoutubeComponent color={color} alt={data.link.alt} />;
      default:
        break;
    }
  };

  return (
    <a
      className={classNames}
      href={data.link.href}
      target={data.link.target}
      aria-label={data.link.alt}
      rel={data.link.rel}
      onClick={() => trackInteraction('social', type, data.link.href, 'footer')}
    >
      {_setIcon()}
    </a>
  );
};

export default ButtonSocialComponent;
